module.exports = __webpack_public_path__ + "img/go_shops_small.6288b570.svg";